import * as React from 'react';
import { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { IUserInfo } from '../../models/IUserInfo';
import { AppUrls } from '../../constants/AppUrls'
import NavMenu from '../NavMenu/NavMenu';
import Footer from '../../components/Login/Footer';
import { BigFooter } from '../../components/Login/BigFooter';
import { PinModal } from '../../controls/PinModal';

function MapState(state) {
    return {
        UserInfo: state.Profile
    }
}

async function sha256(text) {
    const textAsBuffer = new TextEncoder().encode(text);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', textAsBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const digest = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return digest;
}

interface IProps extends RouteComponentProps<any> {
    UserInfo: IUserInfo | null
}

class AppChooseComponent extends Component<IProps, any> {
    constructor(props) {
        super(props);

        this.state = {
            PinModalVisible: true,
            renderFizja: false,
        }
        const { UserInfo, history } = this.props;
        if (UserInfo !== null) {
            if (UserInfo.isAuthenticated === false) {
                history.push('/');
            }
        }
    }

    public componentDidMount(): void {
        const { UserInfo } = this.props;

        if (UserInfo !== null) {
            this.handleFizjaPortal();
        }
    }

    public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<any>, snapshot?: any): void {
        const { UserInfo: prevUserInfo } = prevProps;
        const { UserInfo } = this.props;
        
        if (
            UserInfo &&
            (
                prevUserInfo === null ||
                prevUserInfo.userName !== UserInfo.userName
            )
        ) {
            this.handleFizjaPortal();
        }
    }

    public componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.UserInfo !== null) {
            if (nextProps.UserInfo.isAuthenticated === false) {
                this.props.history.push('/');
            }
        }
    }

    public render() {
        const { history, UserInfo } = this.props;
        const { PinModalVisible, renderFizja } = this.state;
        if (this.props.UserInfo === null) {
            return (<div />)
        }
        return (
            <div className="login-component route-component form-component">
                <NavMenu history={history} />
                {UserInfo && UserInfo.showPinFeature && PinModalVisible &&
                    <PinModal OnAbortClick={this.OnModalClose} />
                }
                <div className="app-choose-container">
                    <div className="app-chooser-content">
                        <div className="header">
                            <h3>Do którego serwisu chcesz przejść?</h3>
                        </div>
                        <div className="applications-container">
                            <a className="app-portal" href={AppUrls.PORTAL_URL}>
                                <div className="app-portal__icon portal-icon" />
                                <div className="app-portal__icon-container">
                                    <p className="app-portal__title">Portal Fizjoterapeuty</p>
                                    <p className="app-portal__description">Portal informacyjny, pozwalający na złożenie wniosków do KIF</p>
                                </div>
                            </a>
                            <a className="app-portal" href={AppUrls.ZF_URL}>
                                <div className="app-portal__icon zf-icon" />
                                <div className="app-portal__icon-container">
                                    <p className="app-portal__title">Znajdź Fizjoterapeutę</p>
                                    <p className="app-portal__description">Twoja wirtualna wizytówka pozwalająca zdobyć pacjentów</p>
                                </div>
                            </a>
                            <a className="app-portal" href={AppUrls.EDM_URL}>
                                <div className="app-portal__icon edm-icon" />
                                <div className="app-portal__icon-container">
                                    <p className="app-portal__title">Finezjo</p>
                                    <p className="app-portal__description">Program do elektronicznej dokumentacji medycznej</p>
                                </div>
                            </a>
                            {renderFizja && (
                                <a className="app-portal" href={AppUrls.FIZJA_URL}>
                                    <div className="app-portal__icon fizja-icon" />
                                    <div className="app-portal__icon-container">
                                        <p className="app-portal__title">Fizja</p>
                                        <p className="app-portal__description">Platforma szkoleniowa dla fizjoterapeutów</p>
                                    </div>
                                    <div className="app-portal__footer">
                                    Sfinansowano w ramach reakcji Unii na pandemię COVID-19
                                        <div className="app-portal__footer-icons">
                                            <div className="app-portal__footer-icon app-portal__footer-icon--FE" />
                                            <div className="app-portal__footer-icon app-portal__footer-icon--RP" />
                                            <div className="app-portal__footer-icon app-portal__footer-icon--UE" />
                                        </div>
                                    </div>
                                </a>
                            )}
                        </div>
                    </div>
                </div>
                <BigFooter />
                <Footer />
            </div>
        );
    }

    private OnModalClose = () => {
        this.setState({
            PinModalVisible: false
        });
    }

    private async handleFizjaPortal() {
        try {
            const { UserInfo } = this.props;
            if (UserInfo === null) {
                return;
            }

            const [ resp, hash ] = await Promise.all([
                fetch('/hashes.json?' + Date.now()),
                sha256(UserInfo.userName.toUpperCase()),
            ]);

            const hashes = await resp.json();
            if (
                hashes.includes('*') ||
                hashes.includes(hash)
            ) {
                this.setState({ renderFizja: true });
            }
        } catch (e) { }
    }
}

export default connect(MapState)(AppChooseComponent);


// WEBPACK FOOTER //
// ./src/components/Login/AppChoose.tsx